import React from 'react';
import { Container, Wrapper, Title, Content, Advantage, Text } from './styled';

const advantages = [
    {
        icon: '/static/images/videocontrol/icons/setup.svg',
        text: 'Простая установка за 5 минут'
    },
    {
        icon: '/static/images/videocontrol/icons/hd.svg',
        text: 'Высокое качество видео'
    },
    {
        icon: '/static/images/videocontrol/icons/cloud.svg',
        text: 'Запись архива в облако'
    },
    {
        icon: '/static/images/videocontrol/icons/internet.svg',
        text: 'Подключение по Wi-Fi'
    },
    {
        icon: '/static/images/videocontrol/icons/mobile.svg',
        text: 'Просмотр видео на ПК и мобильных'
    },
];

const Advantages = () => {
    return <Wrapper>
        <Container>
            <Title>Преимущества видеокамеры</Title>
            <Content>
                { advantages.map(({ icon, text }, index) => <Advantage key={`advantage-${index}`}>
                        <div>
                            <img src={icon} alt={text} />
                        </div>
                        <Text>
                            {text}
                        </Text>
                    </Advantage>)
                }
            </Content>
        </Container>
    </Wrapper>;
};

export default Advantages;
